import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MyTools = () => {
  const navigate = useNavigate();
  const [installedTools, setInstalledTools] = useState([]);

  useEffect(() => {
    // In a real app, this would be an API call
    // For now, we'll use localStorage to persist installed tools
    const storedTools = localStorage.getItem('installedTools');
    if (storedTools) {
      setInstalledTools(JSON.parse(storedTools));
    }
  }, []);

  const handleRemoveTool = (toolId) => {
    const updatedTools = installedTools.filter(tool => tool.id !== toolId);
    setInstalledTools(updatedTools);
    localStorage.setItem('installedTools', JSON.stringify(updatedTools));
  };

  const handleLaunchTool = (tool) => {
    // Update last used timestamp
    const updatedTools = installedTools.map(t => 
      t.id === tool.id ? { ...t, lastUsed: new Date().toISOString() } : t
    );
    setInstalledTools(updatedTools);
    localStorage.setItem('installedTools', JSON.stringify(updatedTools));
    
    // In a real app, this would launch the tool
    console.log('Launching tool:', tool.title);
  };

  if (installedTools.length === 0) {
    return (
      <div className="my-tools-dashboard">
        <h1>My Tools</h1>
        <p>You haven't installed any tools yet.</p>
        <button 
          className="button button-primary"
          onClick={() => navigate('/business-tool-marketplace')}
        >
          Browse Tools
        </button>
      </div>
    );
  }

  return (
    <div className="my-tools-dashboard">
      <h1>My Tools</h1>
      <div className="my-tools-grid">
        {installedTools.map(tool => (
          <div key={tool.id} className="my-tool-card">
            {tool.imageUrl && (
              <img 
                src={tool.imageUrl} 
                alt={tool.title} 
                className="tool-image"
              />
            )}
            <div className="tool-content">
              <h3 className="tool-title">{tool.title}</h3>
              <p className="tool-description">{tool.description}</p>
              <div className="tool-meta">
                <span className="tool-category">{tool.category}</span>
                {tool.lastUsed && (
                  <span className="tool-last-used">
                    Last used: {new Date(tool.lastUsed).toLocaleDateString()}
                  </span>
                )}
              </div>
            </div>
            <div className="my-tool-actions">
              <button
                className="button button-primary"
                onClick={() => handleLaunchTool(tool)}
              >
                Launch
              </button>
              <button
                className="button button-secondary"
                onClick={() => navigate(`/business-tool-marketplace/tool/${tool.id}`)}
              >
                View Info
              </button>
              <button
                className="button button-danger"
                onClick={() => handleRemoveTool(tool.id)}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default MyTools;